module.exports = __webpack_public_path__ + "media/images/revenuemanager-9edd7868b6d652c0ac621dd7d8327b9c.svg";